export default "__VITE_ASSET__CPlTg1yP__"